<template>
  <v-container fluid class="pa-0">
    <!---------->
    <toolbar
      ref="toolbar"
      :items="datatableItems"
      @search="search"
      @advanced-search="advancedSearch"
      @clear-search="clearSearch"
    />
    <datatable
      :search="searchObject"
      @items="getDatatableItems"
      @movement="openMovementDialog"
      @images="openImagesCarousel"
      @details="openDetailsDialog"
      @return="openReturnDialog"
      @print="printReceipt"
      @qr="openQrDialog"
      @view-car="openCarDialog"
      @show-notes="openNotesDialog"
      @share="openShareDialog"
      @view-part="openViewPartDialog"
    />
    <movement-dialog ref="movementDialog" />
    <qr-dialog ref="qrDialog" />
    <img-carousel ref="imgCarousel" />
    <details-dialog
      ref="detailsDialog"
      @close="''"
      @delete-applicability="getSales"
    />
    <return-dialog ref="returnDialog" @close="getSales" />
    <car-dialog ref="carDialog" />
    <notes-dialog ref="notesDialog" />
    <share-dialog ref="shareDialog" />
    <view-part ref="partDialog" @open-img-dialog="openImageDialog" />
    <img-dialog ref="imgDialog" />
  </v-container>
</template>

<script>
import moment from "moment";
import { Printd } from "printd";

import Toolbar from "@/components/Sales/toolbar.vue";
import Datatable from "@/components/Sales/datatable.vue";
import ReturnDialog from "@/components/Sales/returnDialog.vue";
import CarDialog from "@/components/carDialog.vue";
import DetailsDialog from "@/components/detailsDialog.vue";
import MovementDialog from "@/components/movementDialog.vue";
import ImgCarousel from "@/components/imgCarousel.vue";
import QrDialog from "@/components/qrDialog.vue";
import NotesDialog from "@/components/notesDialog.vue";
import ShareDialog from "@/components/Sales/shareDialog.vue";
import PartDetails from "@/components/Sales/PartDetails.vue";
import ImgDialog from "@/components/imgDialog.vue";
export default {
  components: {
    toolbar: Toolbar,
    datatable: Datatable,
    "return-dialog": ReturnDialog,
    "car-dialog": CarDialog,
    "details-dialog": DetailsDialog,
    "movement-dialog": MovementDialog,
    "img-carousel": ImgCarousel,
    "qr-dialog": QrDialog,
    "notes-dialog": NotesDialog,
    "share-dialog": ShareDialog,
    "view-part": PartDetails,
    "img-dialog": ImgDialog,
  },
  data: () => ({
    searchObject: {
      type: null,
      data: {},
    },
    datatableItems: [],
  }),
  mounted() {
    const { id } = this.$route.query;

    if (id) {
      const { toolbar } = this.$refs;
      toolbar.setId(id);
      toolbar.searchMethod();
    }
  },
  methods: {
    getSales() {
      // Fired when closing edit and actions dialog.
      if (this.searchObject.type === null) {
        this.clearSearch();
      } else if (this.searchObject.type === "regularSearch") {
        this.search(this.searchObject.data);
      } else if (this.searchObject.type === "advancedSearch") {
        this.advancedSearch(this.searchObject.data);
      }
    },
    /* Search ----------------------------------------------------------------------------------- */
    search(data) {
      this.searchObject = {
        type: "regularSearch",
        data,
      };
    },
    advancedSearch(data) {
      this.searchObject = {
        type: "advancedSearch",
        data,
      };
    },
    clearSearch() {
      this.searchObject = {
        type: null,
        data: {},
      };
    },
    /* Datatable Items -------------------------------------------------------------------------- */
    getDatatableItems(data) {
      this.datatableItems = data;
    },
    /* Details Dialog --------------------------------------------------------------------------- */
    openDetailsDialog(data) {
      const { detailsDialog } = this.$refs;
      detailsDialog.open(data);
    },
    /* Return Dialog ---------------------------------------------------------------------------- */
    openReturnDialog(data) {
      const { returnDialog } = this.$refs;
      returnDialog.open(data);
    },
    openMovementDialog(data) {
      const { movementDialog } = this.$refs;
      movementDialog.open(data);
    },
    /* QR Dialog -------------------------------------------------------------------------------- */
    openQrDialog(data) {
      const { qrDialog } = this.$refs;
      qrDialog.open(data);
    },
    /* Img Carousel ----------------------------------------------------------------------------- */
    openImagesCarousel(data) {
      const { imgCarousel } = this.$refs;
      imgCarousel.open(data);
    },
    /* Car Dialog ------------------------------------------------------------------------------- */
    openCarDialog(data) {
      const { carDialog } = this.$refs;
      carDialog.open(data);
    },
    /* Notes dialog ----------------------------------------------------------------------------- */
    openNotesDialog(notes) {
      const { notesDialog } = this.$refs;
      notesDialog.open(notes);
    },
    /* Print Receipt ---------------------------------------------------------------------------- */
    printReceipt(data) {
      const content = document.createElement("div");
      content.innerHTML = `
      <div class="main">
        <div class="header">
          <h3>LEKO Tech</h3>
          <p>
            ${this.$t("sales.table.date_created")}: ${moment(data.date_created).format("LLL")}
          </p>
        </div>
        <p>-----------------------------------------</p>
        <div class="row">
          <div class="column">
            <p>PART: </p>
          </div>
          <div class="column">
            <span class="price">
              <p>${data.part.old_id.slice(-6)}</p>
            </span>
          </div>
        </div>
        <p>-----------------------------------------</p>
        <div class="row">
          <div class="column">
            <p>${data.part.title ? data.part.title.it : ""}: </p>
          </div>
          <div class="column">
            <span class="price">
              <p>${data.part.price} ${data.part.currency}</p>
            </span>
          </div>
        </div>
        <p>-----------------------------------------</p>
        <div class="row">
          <div class="column">
            <p>TOTAL: </p>
          </div>
          <div class="column">
            <span class="price">
              <p>${data.part.price} ${data.part.currency}</p>
            </span>
          </div>
        </div>
        <p>-----------------------------------------</p>
        <div class="footer">
          <p>${this.$t("sales.client")}: ${data.client ? data.client.name : ""} ${data.client ? data.client.surname : ""}</p>
          <p>${this.$t("sales.seller")}: ${data.user ? data.user.name : ""}</p>
          <h4>
            ${this.$t("sales.table.return_date")}: ${moment(data.return_date).format("LL")}
          </h4>
        </div>
      </div>
      `;
      const css = [
        `
        .main {
          font-family: "Verdana";
          max-width: 300px;
          margin: 0 auto;
        }
        .header {
          text-align: center;
        }
        .footer {
          text-align: center;
        }
        .row {
          display: flex;
        }
        .column {
          width: 100%;
          float: left;
          display: 50%;
        }
        .price {
          float: right;
        }
      `,
      ];
      const d = new Printd();
      d.print(content, css);
    },
    /* Share Dialog ----------------------------------------------------------------------------- */
    openShareDialog(data) {
      const { shareDialog } = this.$refs;
      shareDialog.open(this.selected ? this.selectedItems : [data]);
    },
    /* Part details Dialog ----------------------------------------------------------------------------- */
    openViewPartDialog(data) {
      const { partDialog } = this.$refs;
      partDialog.open(data);
    },
    /* Img Dialog ------------------------------------------------------------------------------- */
    openImageDialog(image) {
      const { imgDialog } = this.$refs;
      imgDialog.open(image);
    },
  },
};
</script>
